<template lang="html">
  <tr>
    <td class="column-id">
      {{ model.id }}
    </td>

    <td class="column-name">
      {{ model.name }}
    </td>

    <td class="column-parent_name">
      {{ model.parent ? model.parent.name : '' }}
    </td>

    <td class="column-response_count">
      {{ model.responses_count }}
    </td>

    <td class="column-is_base">
      {{ model.is_base ? '&bull;' : '' }}
    </td>

    <td class="column-is_active">
      {{ model.is_active ? '&bull;' : '' }}
    </td>

    <td class="column-on_top">
      {{ model.on_top ? '&bull;' : '' }}
    </td>

    <td class="column-priority">
      {{ model.priority }}
    </td>

    <td class="column-is_hidden">
      {{ model.is_hidden ? '&bull;' : '' }}
    </td>

    <!-- <td class="column-color">
      {{ model.color }}
    </td> -->

  </tr>
</template>

<script>
  export default {
    name: 'response-status-row',

    components: {},

    props: {
      model: Object
    }
  }
</script>

<style lang="scss" scoped>

    .column-vacancies * {
        font-size: 12px;
    }

    .vcv-button {
        height: auto;
        padding: 1px 4px 1px 4px;
    }

    .vacancies-list {
        position: absolute;
        z-index: 9999;
        border: 1px solid grey;
        background: white;
        padding: 2px;

    }

    .vacancies-list * {
        transition-duration: 0s;
        transition-delay: 0s;
    }

</style>
